import { HttpInterceptorFn } from '@angular/common/http';
import {inject} from "@angular/core";
import {LoadingService} from "../services/loading.service";
import {finalize} from "rxjs";

export const loadingInterceptorFunctional: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService)
  loadingService.show()
  return next(req).pipe(
    finalize(() => {
      loadingService.hide()
    })
  )
};
